<template>
  <div class="coupon-dia">
    <van-popup v-model="showCouponPopup" position="bottom" @close="close" v-if="validCouponListSort">
      <div class="title">{{ $t('lang.BaseModule.k016') }}</div>
      <van-tabs v-model="active" swipeable>
        <van-tab
          v-for="tabOption in couponTabTit"
          :title="tabOption.id == 0 ? `${tabOption.tit0}(${validCouponListSort.length})` : `${tabOption.tit1}(${expiredCouponList.length})`"
          :key="tabOption.id"
        >
          <!-- 有效优惠券 -->
          <div v-if="tabOption.id == 0" class="tab tab1">
            <div class="coupon" v-for="(item, index) in validCouponListSort" :key="index" @click="chooseCoupon(item, index)">
              <div class="left">
                <div class="coupon-head"></div>
                <div class="dis-text">
                  <p class="text">{{ $t('lang.CommonModule.k010') }} {{ item.amount }}</p>
                  <p class="text-tip">
                    {{ $t('lang.OtherModule.k007') }}{{ item.minUseAmount }}
                    <img :src="getMatchImg('coin')" />
                    {{ $t('lang.OtherModule.k004') }}
                  </p>
                  <span class="text-time">Expires: {{ handleMoment(item.expiredTime, 'YYYY/MM/DD') }}</span>
                </div>
              </div>
              <div class="right">
                <div class="coupon-num">
                  <div v-if="chooseCouponId && chooseCouponId == item.couponRecordId" class="radio-checked"></div>
                  <div v-else class="radio"></div>
                </div>
              </div>
            </div>
            <div class="no-coupons" v-if="validCouponListSort.length == 0">{{ $t('lang.OtherModule.k005') }}</div>
          </div>

          <!-- 过期优惠券 -->
          <div v-if="tabOption.id == 1" class="tab tab2">
            <div class="coupon expired-coupon" v-for="(item, index) in expiredCouponList" :key="index">
              <div class="left">
                <div class="coupon-head"></div>
                <div class="dis-text">
                  <p class="text">{{ $t('lang.CommonModule.k010') }} {{ item.amount }}</p>
                  <!-- prettier-ignore -->
                  <p class="text-tip">
                    {{ $t('lang.OtherModule.k007') }}{{ item.minUseAmount }}<img :src="getMatchImg('coin')" />{{ $t('lang.OtherModule.k004') }}
                  </p>
                  <span class="text-time">Expires: {{ handleMoment(item.expiredTime, 'YYYY/MM/DD') }}</span>
                </div>
              </div>
              <div class="right">
                <div class="coupon-num">
                  <div class="expired">{{ $t('lang.BaseModule.k022') }}</div>
                </div>
              </div>
            </div>
            <div class="no-coupons" v-if="expiredCouponList.length == 0">{{ $t('lang.OtherModule.k005') }}</div>
          </div>
        </van-tab>
      </van-tabs>
      <div
        class="confirm-btn"
        :class="{ 'no-click': (active == 0 && (validCouponListSort.length == 0 || this.chooseCouponId == null)) || active == 1 }"
        @click="handleConfirm"
      >
        {{ $t('lang.CommonModule.k005') }}
      </div>
      <div :style="{ width: '100%', height: `${bottomBarHeight}px` }"></div>
    </van-popup>
  </div>
</template>

<script>
// store 优惠卷
export default {
  props: {
    active: {
      default: 0,
    },
    showCouponPopup: {},
    couponTabTit: {},
    validCouponListSort: {}, // 排序之后有效的优惠劵
    maxCoupon: {}, // 最大的优惠劵
    expiredCouponList: {}, // 无效的优惠劵,
  },
  data() {
    return {
      chooseCouponId: null,
      chooseCouponOption: {},
    }
  },
  methods: {
    close() {
      this.$emit('close', false)
    },

    // 选中优惠卷
    chooseCoupon(item) {
      this.chooseCouponOption = item
      this.chooseCouponId = item.couponRecordId
    },

    // 确定选中
    handleConfirm() {
      if (this.chooseCouponId) {
        if (this.chooseCouponOption) {
          this.$emit('confirmChooseCouponId', this.chooseCouponOption)
        } else {
          this.$emit('confirmChooseCouponId', this.maxCoupon)
        }
      } else {
        this.close()
      }
    },
  },
  watch: {
    maxCoupon: {
      deep: true,
      immediate: true,
      handler(newVal) {
        if (newVal && newVal.couponRecordId) {
          this.chooseCouponId = newVal.couponRecordId
        }
      },
    },
    validCouponListSort: {
      deep: true,
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.maxCoupon = this.validCouponListSort[0] || null
          this.$forceUpdate()
        }
      },
    },
  },
}
</script>

<style lang="less" scoped>
.coupon-dia {
  font-family: 'Inter-Regular';
  .van-popup {
    width: 100%;
    min-height: 432px;
    padding: 20px 24px;
    overflow: hidden;
  }
  .title {
    width: 100%;
    height: 20px;
    font-weight: bold;
    font-size: 17px;
    color: #333333;
    line-height: 20px;
    text-align: center;
  }
  .tab {
    height: 260px;
    overflow-y: auto !important;
    color: #333333;
  }

  .coupon {
    width: 100%;
    height: 112px;
    margin-bottom: 7px;
  }

  .expired-coupon {
    filter: grayscale(1);
    pointer-events: none;
  }

  .coupon,
  .expired-coupon {
    display: flex;
    background-color: #ffffff;
    border-radius: 10px;
    box-shadow: 2px 2px 4px rgba(75, 34, 0, 0.05);
    position: relative;
    .left {
      flex: 1;
      display: flex;
      align-items: center;
      .coupon-head {
        width: 44px;
        height: 100%;
        background: url(./images/ch-on-joychat.webp) top left / auto 100% no-repeat;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .left-num {
        width: 90px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .money-icon {
          width: 36px;
          height: 36px;
        }
        .money-num {
          margin-bottom: 10px;
          font-weight: bold;
          font-size: 20px;
          color: #ff483c;
          line-height: 24px;
        }
      }
      .dis-text {
        width: 100%;
        height: 100%;
        margin-left: 16px;
        padding: 12px 0 0 8px;
        .text {
          display: block;
          width: 100%;
          margin-bottom: 6px;
          color: #2dcd90;
          font-feature-settings: 'liga' off, 'clig' off;
          font-family: 'Outfit-Bold';
          font-size: 21px;
          font-style: normal;
          font-weight: 600;
          line-height: 30px;
          padding-bottom: 11px;
          border-bottom: 1px dashed #cccccc;
        }
        .text-tip,
        .text-time {
          color: #999999;
          font-size: 14px;
          font-weight: 400;
          line-height: 22px;
        }
        .text-tip {
          > img {
            width: 12px;
            margin: 0 2px;
          }
        }
      }
    }

    .right {
      position: absolute;
      right: 16px;
      bottom: 8px;
      .coupon-num {
        .radio {
          width: 28px;
          height: 28px;
          background: url(./images/uncheck-icon.webp) center / 100% no-repeat;
          border-radius: 50%;
        }
        .radio-checked {
          width: 28px;
          height: 28px;
          border-radius: 50%;
          background: url(./images/check-icon.webp) center / 13px 9px no-repeat;
          background-color: #f95151;
        }
        .expired {
          color: #ccc;
          text-align: right;
          font-feature-settings: 'liga' off, 'clig' off;
          font-family: 'Outfit-Bold';
          font-size: 15px;
          font-style: normal;
          font-weight: 600;
        }
      }
    }
  }

  .confirm-btn {
    width: 289px;
    height: 40px;
    margin: 17px auto 0;
    background: #2dcd90;
    border-radius: 20px;
    font-family: 'Inter-Regular';
    font-weight: 500;
    font-size: 16px;
    color: #ffffff;
    line-height: 40px;
    text-align: center;
  }

  .no-click {
    pointer-events: none;
    background: #e1e1e1;
  }

  .no-coupons {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: 'Inter-Regular';
    font-weight: 400;
    font-size: 17px;
    color: #999999;
    line-height: 20px;
  }
}
html[lang='ar'],
html[lang='fa'],
html[lang='he'] {
  .coupon-dia .coupon .left .dis-text,
  .coupon-dia .expired-coupon .left .dis-text {
    margin-right: 16px;
    margin-left: unset;
  }
  .coupon-dia .coupon .right,
  .coupon-dia .expired-coupon .right {
    right: unset;
    left: 16px;
  }
}
</style>

<style lang="scss">
.coupon-dia {
  .van-popup {
    background-color: #f8f8f8;
  }
  .van-tabs__nav {
    background-color: #f8f8f8 !important;
  }
}
</style>

<style lang="scss" scoped>
::v-deep .van-tab {
  font-size: 15px;
  color: #999999;
}
::v-deep .van-tab--active {
  color: #333333;
  font-weight: 600;
}
::v-deep .van-tabs__line {
  display: none;
}

// 去掉滚动条
::-webkit-scrollbar {
  display: none;
}
::-webkit-scrollbar-track {
  display: none;
}
</style>
